import * as Konva from '../../assets/konva';
import {Create} from './create';
import {Sizes} from './sizes/sizes';

export class Drawer extends Create {
  subId;
  drawer_group;
  coef;
  create;
  minSize;

  constructor(subId, coef, create, active, minSize) {
    super(coef, create);
    this.subId = subId;
    this.coef = coef;
    this.create = create;
    this.minSize = minSize;
    
    switch (this.subId) {
      case this.coef.element_Sub_id.drawerSimple: {
        this.createSimple(active);
      }
        break;
      case this.coef.element_Sub_id.drawerWithLength: {
        this.createWithLength(active);
      }
        break;
      case this.coef.element_Sub_id.drawerWithLengthLock: {
        this.createWithLengthLock(active);
      }
        break;
      case this.coef.element_Sub_id.drawerSimpleLock: {
        this.createSimpleLock(active);
      }
        break;
      case this.coef.element_Sub_id.drawerSimpleSpec: {
        this.createSimpleSpec(active);
      }
        break;
      case this.coef.element_Sub_id.drawerSimpleSpecD: {
          this.createSimpleSpecD(active);
        }
          break;
    }
  }
  createSimpleSpecD(active) {
    this.coef.countNameElement++;
    this.drawer_group = new Konva.Group({
      x: 400,
      y: -500,
      width: 75,
      draggable: active,
      name: 'element' + this.coef.countNameElement,
      params: {
        removable: true,
        type: this.coef.id_element.drawer,
        subId: this.subId
      },
      bind: [],
    });

    const drawerRect = new Konva.Rect({
      x: 0,
      y: 0,
      width: 75,
      height: 35,
      name: 'width',
      fill: this.coef.color,
    });
 
    this.drawer_group.add(drawerRect);

    this.dragEnd(this.drawer_group, this.coef.product, (pos, xy) => {
      this.createSimpleApiSpecD(pos);
    });
  }
  createSimpleApiSpecD(pos, heightDrawer?, neo?) {
    this.coef.countNameElement++;
    const xy = {x: pos.evt.layerX, y: pos.evt.layerY};
    if (this.coef.pramsId == 17 && this.coef.hingedFactory
        && this.coef.hingedFactory.drawerZoneBlocksPlacement('shelf', xy)) {
      this.coef.errorTrigger('Не можна поставити шухляду в зоні шухляди.');
      this.coef.shapesLayerw.batchDraw();
      return;
    }
    const contours = this.create.getTangentElement(pos, this.drawer_group, this.coef.shapesLayerw);
    if (contours) {
      const isOnWhat = this.isOnWhat(pos, this.drawer_group, this.coef.shapesLayerw);
      const lastDrawer = {bottom: null};
      if (isOnWhat) {
        if (this.getlastdrawer(isOnWhat, lastDrawer)) {
          contours['top'] = this.getlastdrawer(isOnWhat, lastDrawer);
        }
      }
      let height = this.coef.drawer.drawHeightSpec;
      if (heightDrawer) {
        height = heightDrawer;
      }
      const globX = contours['left'].attrs.x + contours['left'].attrs.width;
      const globY = contours['top'].attrs.y + (contours['top'].attrs.height ? contours['top'].attrs.height : contours['top'].attrs.params.height);
      let removable = true;
      if (neo) {
        removable = false;
      }
      if (this.blockDrawerCreate(contours, pos, neo)) {
        const width = contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width;
        const drawer_group_create = new Konva.Group({
          x: globX,
          y: globY,
          name: 'element' + this.coef.countNameElement,
          width: contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width,
          params: {
            removable: removable,
            type: this.coef.id_element.drawer,
            height: height,
            subId: this.subId,
            touches: 'noTouched',
            neo: neo ? neo : false,
            innerSection: neo ? neo : false
          },
          bind: [],
        });
        const drawerRectCreate = new Konva.Rect({
          x: 0,
          y: 0,
          width: drawer_group_create['attrs'].width,
          height: height,
          name: 'width',
          fill: neo ? this.coef.colorFacad : this.coef.color,
          strokeWidth: 1,
          stroke: 'black',
          params: {
            facad: neo ? neo : false,
          },
          dash: []
        });
        const drawerCenterCreate = new Konva.Rect({
          x: 0,
          y: 0,
          width:drawer_group_create['attrs'].width,
          height: 5,
          name: 'width',
          fill: '#6c6c6c',
          strokeWidth: 1,
          stroke: 'black',
        });
        const drawerText= new Konva.Text({
          x: (contours['right'].attrs.x - contours['left'].attrs.x ) - 20,
          y: 10,
          text: 'Д',
          fontSize: 15,
          fontFamily: 'Calibri',
          fill: 'black'
        });
        this.create.bindingTocounters(
          contours['left'],
          contours['right'],
          contours['top'],
          contours['bottom'],
          drawer_group_create,
          'horizon',
        );
        drawer_group_create.add(drawerRectCreate);
        drawer_group_create.add(drawerCenterCreate)
        drawer_group_create.add(drawerText)
        this.coef.shapesLayerw.add(drawer_group_create);
        this.coef.shapesLayerw.batchDraw();
        this.create.priceSend();
        if (heightDrawer) {
          drawer_group_create['attrs'].params.touches = 'Touched';
        }
        this.addHingePlankasToDrawer(drawer_group_create, contours, height, drawerRectCreate.fill());
      this.resizeDraw(drawer_group_create, contours, pos);
      }
    }
  }
  createSimpleSpec(active) {
    this.coef.countNameElement++;
    this.drawer_group = new Konva.Group({
      x: 400,
      y: -500,
      width: 75,
      draggable: active,
      name: 'element' + this.coef.countNameElement,
      params: {
        removable: true,
        type: this.coef.id_element.drawer,
        subId: this.subId
      },
      bind: [],
    });

    const drawerRect = new Konva.Rect({
      x: 0,
      y: 0,
      width: 75,
      height: 35,
      name: 'width',
      fill: this.coef.color,
    });
 
    this.drawer_group.add(drawerRect);

    this.dragEnd(this.drawer_group, this.coef.product, (pos, xy) => {
      this.createSimpleApiSpec(pos);
    });
  }
  createSimpleApiSpec(pos, heightDrawer?, neo?) {
    this.coef.countNameElement++;
    const xy = {x: pos.evt.layerX, y: pos.evt.layerY};
    if (this.coef.pramsId == 17 && this.coef.hingedFactory
        && this.coef.hingedFactory.drawerZoneBlocksPlacement('shelf', xy)) {
      this.coef.errorTrigger('Не можна поставити шухляду в зоні шухляди.');
      this.coef.shapesLayerw.batchDraw();
      return;
    }
    const contours = this.create.getTangentElement(pos, this.drawer_group, this.coef.shapesLayerw);
    if (contours) {
      const isOnWhat = this.isOnWhat(pos, this.drawer_group, this.coef.shapesLayerw);
      const lastDrawer = {bottom: null};
      if (isOnWhat) {
        if (this.getlastdrawer(isOnWhat, lastDrawer)) {
          contours['top'] = this.getlastdrawer(isOnWhat, lastDrawer);
        }
      }
      let height = this.coef.drawer.drawHeightSpec;
      if (heightDrawer) {
        height = heightDrawer;
      }
      const globX = contours['left'].attrs.x + contours['left'].attrs.width;
      const globY = contours['top'].attrs.y + (contours['top'].attrs.height ? contours['top'].attrs.height : contours['top'].attrs.params.height);
      let removable = true;
      if (neo) {
        removable = false;
      }
      if (this.blockDrawerCreate(contours, pos, neo)) {
        const width = contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width;
        const drawer_group_create = new Konva.Group({
          x: globX,
          y: globY,
          name: 'element' + this.coef.countNameElement,
          width: contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width,
          params: {
            removable: removable,
            type: this.coef.id_element.drawer,
            height: height,
            subId: this.subId,
            touches: 'noTouched',
            neo: neo ? neo : false,
            innerSection: neo ? neo : false
          },
          bind: [],
        });
        const drawerRectCreate = new Konva.Rect({
          x: 0,
          y: 0,
          width: drawer_group_create['attrs'].width,
          height: height,
          name: 'width',
          fill: neo ? this.coef.colorFacad : this.coef.color,
          strokeWidth: 1,
          stroke: 'black',
          params: {
            facad: neo ? neo : false,
          },
          dash: []
        });
        const drawerCenterCreate = new Konva.Rect({
          x: 0,
          y: 0,
          width:drawer_group_create['attrs'].width,
          height: 5,
          name: 'width',
          fill: '#6c6c6c',
          strokeWidth: 1,
          stroke: 'black',
        });

        this.create.bindingTocounters(
          contours['left'],
          contours['right'],
          contours['top'],
          contours['bottom'],
          drawer_group_create,
          'horizon',
        );
        drawer_group_create.add(drawerRectCreate);
        drawer_group_create.add(drawerCenterCreate)
        this.coef.shapesLayerw.add(drawer_group_create);
        this.coef.shapesLayerw.batchDraw();
        this.create.priceSend();
        if (heightDrawer) {
          drawer_group_create['attrs'].params.touches = 'Touched';
        }
        this.addHingePlankasToDrawer(drawer_group_create, contours, height, drawerRectCreate.fill());
      this.resizeDraw(drawer_group_create, contours, pos);
      }
    }
  }
  createSimple(active) {
    this.coef.countNameElement++;
    this.drawer_group = new Konva.Group({
      x: 400,
      y: -500,
      width: 75,
      draggable: active,
      name: 'element' + this.coef.countNameElement,
      params: {
        removable: true,
        type: this.coef.id_element.drawer,
        subId: this.subId
      },
      bind: [],
    });

    const drawerRect = new Konva.Rect({
      x: 0,
      y: 0,
      width: 75,
      height: 35,
      name: 'width',
      fill: this.coef.color,
    });
    const drawerCenter = new Konva.Rect({
      x: (75 / 2) - 16 / 2,
      y: (35 / 2) - 5 / 2,
      width: 16,
      height: 5,
      name: 'width',
      fill: this.coef.silverColor,
    });
    this.drawer_group.add(drawerRect);
    this.drawer_group.add(drawerCenter);
    this.dragEnd(this.drawer_group, this.coef.product, (pos, xy) => {
      this.createSimpleApi(pos);
    });
  }

  createSimpleApi(pos, heightDrawer?, neo?) {
    this.coef.countNameElement++;
    const xy = {x: pos.evt.layerX, y: pos.evt.layerY};
    if (this.coef.pramsId == 17 && this.coef.hingedFactory
        && this.coef.hingedFactory.drawerZoneBlocksPlacement('shelf', xy)) {
      this.coef.errorTrigger('Не можна поставити шухляду в зоні шухляди.');
      this.coef.shapesLayerw.batchDraw();
      return;
    }
    const contours = this.create.getTangentElement(pos, this.drawer_group, this.coef.shapesLayerw);
    if (contours) {
      const isOnWhat = this.isOnWhat(pos, this.drawer_group, this.coef.shapesLayerw);
      const lastDrawer = {bottom: null};
      if (isOnWhat) {
        if (this.getlastdrawer(isOnWhat, lastDrawer)) {
          contours['top'] = this.getlastdrawer(isOnWhat, lastDrawer);
        }
      }
      let height = this.coef.drawer.drawHeight;
      if (heightDrawer) {
        height = heightDrawer;
      }
      const globX = contours['left'].attrs.x + contours['left'].attrs.width;
      const globY = contours['top'].attrs.y + (contours['top'].attrs.height ? contours['top'].attrs.height : contours['top'].attrs.params.height);
      let removable = true;
      if (neo) {
        removable = false;
      }
      if (this.blockDrawerCreate(contours, pos, neo)) {
        const width = contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width;
        const drawer_group_create = new Konva.Group({
          x: globX,
          y: globY,
          name: 'element' + this.coef.countNameElement,
          width: contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width,
          params: {
            removable: removable,
            type: this.coef.id_element.drawer,
            height: height,
            subId: this.subId,
            touches: 'noTouched',
            neo: neo ? neo : false,
            innerSection: neo ? neo : false
          },
          bind: [],
        });

        const drawerRectCreate = new Konva.Rect({
          x: 0,
          y: 0,
          width: drawer_group_create['attrs'].width,
          height: height,
          name: 'width',
          fill: neo ? this.coef.colorFacad : this.coef.color,
          strokeWidth: 1,
          stroke: 'black',
          params: {
            facad: neo ? neo : false,
          },
          dash: []
        });
        const drawerCenterCreate = new Konva.Rect({
          x: (contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 2 - 16 / 2,
          y: (height / 2) - 5 / 2,
          width: 16,
          height: 5,
          name: 'width',
          fill: this.coef.silverColor,
          strokeWidth: 1,
          stroke: 'black',
        });
        const drawerCenterCreate3 = new Konva.Rect({
          x: (((contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3) * 2) - 16 / 2,
          y: (height / 2) - 5 / 2,
          width: 16,
          height: 5,
          name: 'width',
          fill: this.coef.silverColor,
          strokeWidth: 1,
          stroke: 'black',
        });
        const drawerCenterCreate4 = new Konva.Rect({
          x: (((contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3) * 2) - 16 / 2,
          y: (height / 2) - 5 / 2,
          width: 16,
          height: 5,
          name: 'width',
          fill: this.coef.silverColor,
          strokeWidth: 1,
          stroke: 'black',
          visible: false,
        });
        const drawerCenterCreate2 = new Konva.Rect({
          x: (contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3 - 16 / 2,
          y: (height / 2) - 5 / 2,
          width: 16,
          height: 5,
          name: 'width',
          fill: this.coef.silverColor,
          strokeWidth: 1,
          stroke: 'black',
        });

        this.create.bindingTocounters(
          contours['left'],
          contours['right'],
          contours['top'],
          contours['bottom'],
          drawer_group_create,
          'horizon',
        );
        drawer_group_create.add(drawerRectCreate);
        if (width * this.coef.global_coef >= this.coef.drawer.secondSeparattor) {
          drawer_group_create.add(drawerCenterCreate2);
          drawer_group_create.add(drawerCenterCreate3);
        } else {
          drawer_group_create.add(drawerCenterCreate);
          drawer_group_create.add(drawerCenterCreate4);
        }
        this.coef.shapesLayerw.add(drawer_group_create);
        this.coef.shapesLayerw.batchDraw();
        this.create.priceSend();
        if (heightDrawer) {
          drawer_group_create['attrs'].params.touches = 'Touched';
        }
        this.addHingePlankasToDrawer(drawer_group_create, contours, height, drawerRectCreate.fill());
      this.resizeDraw(drawer_group_create, contours, pos);
      }
    }
  }

  resizeDraw(drawer_group_create, contours, pos) {
    let sideSpace =  this.coef.drawer.sideSpace;
    if(drawer_group_create.attrs.params.subId == 26 || drawer_group_create.attrs.params.subId == 27) {
      sideSpace = this.coef.drawer.sideSpaceSpec
    }
    const globX = contours['left'].attrs.x + contours['left'].attrs.width;
    const globY = contours['top'].attrs.y + (contours['top'].attrs.height ? contours['top'].attrs.height : contours['top'].attrs.params.height);
    let size;
    if (contours['top'].attrs.params.type === this.coef.id_element.shelf) {
      size = new Sizes(this.coef, this.create).createOneSizeVertical(contours, drawer_group_create, true);
      drawer_group_create.add(size);
    }
    const allContour = this.getContourShalf({evt: {layerX: globX, layerY: globY}}, drawer_group_create);
    if (!allContour.contoursShalf['top'].attrs.params['drawerArray']) {
      allContour.contoursShalf['top'].attrs.params['drawerArray'] = [];
    }
    allContour.contoursShalf['top'].attrs.params['drawerArray'].push(drawer_group_create);
    this.drawerAdd({
      evt: {
        layerX: globX,
        layerY: globY
      }
    }, drawer_group_create, allContour.contoursShalf['bottom'], allContour.contoursShalf['top']);
    const countDrawerNow = {count: 1};
    this.countTopDrawer(pos, drawer_group_create, countDrawerNow);
    countDrawerNow.count = this.countDrawerFromX(allContour.contoursShalf['top'], drawer_group_create['attrs'].x);
    if (contours['top'].attrs.params.type === this.coef.id_element.shelf) {
      contours['top'].on('dragmove', () => {
        this.resize(contours['top'], drawer_group_create['attrs'].params.height, size , sideSpace);
      });
    }
    if (drawer_group_create['attrs'].params.touches === 'Touched') {
      allContour.contoursShalf['top'].on('dragmove', () => {
        if (allContour.contoursShalf['top'].attrs.params.drawer) {
        
          this.resizeDrawerAll({
            evt: {
              layerX: globX,
              layerY: globY
            }
          }, drawer_group_create, allContour.contoursShalf['top'], countDrawerNow.count, allContour.contoursShalf['bottom']);
        }
      });
    }
  }

  createSimpleLock(active) {
    this.coef.countNameElement++;
    this.drawer_group = new Konva.Group({
      x: 400,
      y: -500,
      width: 75,
      draggable: active,
      name: 'element' + this.coef.countNameElement,
      params: {
        removable: true,
        type: this.coef.id_element.drawer,
        subId: this.subId
      },
      bind: [],
    });
   
    const drawerRect = new Konva.Rect({
      x: 0,
      y: 0,
      width: 75,
      height: 35,
      name: 'width',
      fill: this.coef.color,
    });
    const drawerCenter = new Konva.Rect({
      x: (75 / 2) - 16 / 2,
      y: (35 / 2) - 5 / 2,
      width: 16,
      height: 5,
      name: 'width',
      fill: this.coef.silverColor,
    });
    const lock = this.createLockDesigne();
    this.drawer_group.add(drawerRect);
    this.drawer_group.add(drawerCenter);
    this.drawer_group.add(lock[0]);
    this.drawer_group.add(lock[1]);
    this.dragEnd(this.drawer_group, this.coef.product, (pos, xy) => {
      this.createSimpleLockApi(pos);
    });
  }

  createSimpleLockApi(pos, heightDrawer?) {
    this.coef.countNameElement++;
    const xy = {x: pos.evt.layerX, y: pos.evt.layerY};
    if (this.coef.pramsId == 17 && this.coef.hingedFactory
        && this.coef.hingedFactory.drawerZoneBlocksPlacement('shelf', xy)) {
      this.coef.errorTrigger('Не можна поставити шухляду в зоні шухляди.');
      this.coef.shapesLayerw.batchDraw();
      return;
    }
    const contours = this.create.getTangentElement(pos, this.drawer_group, this.coef.shapesLayerw);
    const isOnWhat = this.isOnWhat(pos, this.drawer_group, this.coef.shapesLayerw);
    const lastDrawer = {bottom: null};
    if (isOnWhat) {
      if (this.getlastdrawer(isOnWhat, lastDrawer)) {
        contours['top'] = this.getlastdrawer(isOnWhat, lastDrawer);
      }
    }
    let height = this.coef.drawer.drawHeight;
    if (heightDrawer) {
      height = heightDrawer;
    }
    if (this.blockDrawerCreate(contours, pos)) {
      const width = contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width;
      const drawer_group_create = new Konva.Group({
        x: contours['left'].attrs.x + contours['left'].attrs.width,
        y: contours['top'].attrs.y + (contours['top'].attrs.height ? contours['top'].attrs.height : contours['top'].attrs.params.height),
        name: 'element' + this.coef.countNameElement,
        width: contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width,
        params: {
          removable: true,
          type: this.coef.id_element.drawer,
          height: height,
          subId: this.subId
        },
        bind: [],
      });
      const drawerRectCreate = new Konva.Rect({
        x: 0,
        y: 0,
        width: drawer_group_create['attrs'].width,
        height: height,
        name: 'width',
        fill: this.coef.color,
        strokeWidth: 1,
        stroke: 'black',
      });
      const drawerCenterCreate = new Konva.Rect({
        x: (contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 2 - 16 / 2,
        y: (height / 2) - 5 / 2,
        width: 16,
        height: 5,
        name: 'width',
        fill: this.coef.silverColor,
        strokeWidth: 1,
        stroke: 'black',
      });
      const drawerCenterCreate3 = new Konva.Rect({
        x: (((contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3) * 2) - 16 / 2,
        y: (height / 2) - 5 / 2,
        width: 16,
        height: 5,
        name: 'width',
        fill: this.coef.silverColor,
        strokeWidth: 1,
        stroke: 'black',
      });
      const drawerCenterCreate4 = new Konva.Rect({
        x: (((contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3) * 2) - 16 / 2,
        y: (height / 2) - 5 / 2,
        width: 16,
        height: 5,
        name: 'width',
        fill: this.coef.silverColor,
        strokeWidth: 1,
        stroke: 'black',
        visible: false,
      });

      const drawerCenterCreate2 = new Konva.Rect({
        x: (contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3 - 16 / 2,
        y: (height / 2) - 5 / 2,
        width: 16,
        height: 5,
        name: 'width',
        fill: this.coef.silverColor,
        strokeWidth: 1,
        stroke: 'black',
      });
      this.create.bindingTocounters(
        contours['left'],
        contours['right'],
        contours['top'],
        contours['bottom'],
        drawer_group_create,
        'horizon',
      );
      let lock = this.createLockDesigne();
      drawer_group_create.add(drawerRectCreate);
      if (width * this.coef.global_coef >= this.coef.drawer.secondSeparattor) {
        drawer_group_create.add(drawerCenterCreate2);
        drawer_group_create.add(drawerCenterCreate3);
      } else {
        drawer_group_create.add(drawerCenterCreate);
        drawer_group_create.add(drawerCenterCreate4);
      }
      drawer_group_create.add(lock[0]);
      drawer_group_create.add(lock[1]);
      this.coef.shapesLayerw.add(drawer_group_create);
      this.coef.shapesLayerw.batchDraw();
      this.create.priceSend();
      if (heightDrawer) {
        drawer_group_create['attrs'].params.touches = 'Touched';
      }
      this.addHingePlankasToDrawer(drawer_group_create, contours, height, drawerRectCreate.fill());
      this.resizeDraw(drawer_group_create, contours, pos);
    }
  }

  createWithLength(active) {
    this.coef.countNameElement++;
    this.drawer_group = new Konva.Group({
      x: 400,
      y: -500,
      width: 75,
      draggable: active,
      name: 'element' + this.coef.countNameElement,
      params: {
        removable: true,
        type: this.coef.id_element.drawer,
        subId: this.subId
      },
      bind: [],
    });
    const drawerRect = new Konva.Rect({
      x: 0,
      y: 0,
      width: 75,
      height: 35,
      name: 'width',
      fill: this.coef.color,
    });
    const drawerCenter = new Konva.Rect({
      x: (75 / 2) - 16 / 2,
      y: (35 / 2) - 5 / 2,
      width: 16,
      height: 5,
      name: 'width',
      fill: this.coef.silverColor,
    });
    this.drawer_group.add(drawerRect);
    this.drawer_group.add(drawerCenter);

    this.dragEnd(this.drawer_group, this.coef.product, (pos) => {
      this.createWithLengthApi(pos);
    });
  }

  createWithLengthApi(pos, heightDrawer? , neo?) {
    this.coef.countNameElement++;
    const xy = {x: pos.evt.layerX, y: pos.evt.layerY};
    if (this.coef.pramsId == 17 && this.coef.hingedFactory
        && this.coef.hingedFactory.drawerZoneBlocksPlacement('shelf', xy)) {
      this.coef.errorTrigger('Не можна поставити шухляду в зоні шухляди.');
      this.coef.shapesLayerw.batchDraw();
      return;
    }
    const contours = this.create.getTangentElement(pos, this.drawer_group, this.coef.shapesLayerw);
    const isOnWhat = this.isOnWhat(pos, this.drawer_group, this.coef.shapesLayerw);
    const lastDrawer = {bottom: null};
    if (isOnWhat) {
      if (this.getlastdrawer(isOnWhat, lastDrawer)) {
        contours['top'] = this.getlastdrawer(isOnWhat, lastDrawer);
      }
    }
    let height = this.coef.drawer.drawHeight;
    if (heightDrawer) {
      height = heightDrawer;
    }
    let removable = true;
      if (neo) {
        removable = false;
      }
    if (this.blockDrawerCreate(contours, pos , neo)) {
      const width = contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width;
      const drawer_group_create = new Konva.Group({
        x: contours['left'].attrs.x + contours['left'].attrs.width,
        y: contours['top'].attrs.y + (contours['top'].attrs.height ? contours['top'].attrs.height : contours['top'].attrs.params.height),
        name: 'element' + this.coef.countNameElement,
        width: contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width,
        params: {
          removable: removable,
          type: this.coef.id_element.drawer,
          height: height,
          subId: this.subId,
          touches: 'noTouched',
          neo: neo ? neo : false,
          innerSection: neo ? neo : false
        },
        bind: [],
      });
      const drawerRectCreate = new Konva.Rect({
        x: 0,
        y: 0,
        width: drawer_group_create['attrs'].width,
        height: height,
        params: {
          facad: neo ? neo : false,
        },
        name: 'width',
        fill: this.coef.color,
        strokeWidth: 1,
        stroke: 'black',
      });
       const drawerCenterCreate = new Konva.Rect({
          x: (contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 2 - 16 / 2,
          y: (height / 2) - 5 / 2,
          width: 16,
          height: 5,
          name: 'width',
          fill: this.coef.silverColor,
          strokeWidth: 1,
          stroke: 'black',
        });
        const drawerCenterCreate3 = new Konva.Rect({
          x: (((contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3) * 2) - 16 / 2,
          y: (height / 2) - 5 / 2,
          width: 16,
          height: 5,
          name: 'width',
          fill: this.coef.silverColor,
          strokeWidth: 1,
          stroke: 'black',
        });
        const drawerCenterCreate4 = new Konva.Rect({
          x: (((contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3) * 2) - 16 / 2,
          y: (height / 2) - 5 / 2,
          width: 16,
          height: 5,
          name: 'width',
          fill: this.coef.silverColor,
          strokeWidth: 1,
          stroke: 'black',
          visible: false,
        });
        const drawerCenterCreate2 = new Konva.Rect({
          x: (contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3 - 16 / 2,
          y: (height / 2) - 5 / 2,
          width: 16,
          height: 5,
          name: 'width',
          fill: this.coef.silverColor,
          strokeWidth: 1,
          stroke: 'black',
        });
      this.create.bindingTocounters(
        contours['left'],
        contours['right'],
        contours['top'],
        contours['bottom'],
        drawer_group_create,
        'horizon',
      );
      const drawerText= new Konva.Text({
        x: (contours['right'].attrs.x - contours['left'].attrs.x ) - 20,
        y: 10,
        text: 'Д',
        fontSize: 15,
        fontFamily: 'Calibri',
        fill: 'black'
      });
      drawer_group_create.add(drawerRectCreate);
      if (width * this.coef.global_coef >= this.coef.drawer.secondSeparattor) {
        drawer_group_create.add(drawerCenterCreate2);
        drawer_group_create.add(drawerCenterCreate3);
      } else {
        drawer_group_create.add(drawerCenterCreate);
        drawer_group_create.add(drawerCenterCreate4);
      }
      drawer_group_create.add(drawerText)
      this.coef.shapesLayerw.add(drawer_group_create);
      this.coef.shapesLayerw.batchDraw();
      this.create.priceSend();
      if (heightDrawer) {
        drawer_group_create['attrs'].params.touches = 'Touched';
      }
      this.addHingePlankasToDrawer(drawer_group_create, contours, height, drawerRectCreate.fill());
      this.resizeDraw(drawer_group_create, contours, pos);
    }
  }

  createWithLengthLock(active) {
    this.coef.countNameElement++;
    this.drawer_group = new Konva.Group({
      x: 400,
      y: -500,
      width: 75,
      draggable: active,
      name: 'element' + this.coef.countNameElement,
      params: {
        removable: true,
        type: this.coef.id_element.drawer,
        subId: this.subId
      },
      bind: [],
    });
    const drawerRect = new Konva.Rect({
      x: 0,
      y: 0,
      width: 75,
      height: 35,
      name: 'width',
      fill: this.coef.color,
    });
    const lock = this.createLockDesigne();
    this.drawer_group.add(drawerRect);
    this.drawer_group.add(lock[0]);
    this.drawer_group.add(lock[1]);
    this.dragEnd(this.drawer_group, this.coef.product, (pos, xy) => {
      this.createWithLengthLockApi(pos);
    });
  }

  createWithLengthLockApi(pos, heightDrawer?) {
    this.coef.countNameElement++;
    const xy = {x: pos.evt.layerX, y: pos.evt.layerY};
    if (this.coef.pramsId == 17 && this.coef.hingedFactory
        && this.coef.hingedFactory.drawerZoneBlocksPlacement('shelf', xy)) {
      this.coef.errorTrigger('Не можна поставити шухляду в зоні шухляди.');
      this.coef.shapesLayerw.batchDraw();
      return;
    }
    const contours = this.create.getTangentElement(pos, this.drawer_group, this.coef.shapesLayerw);
    const isOnWhat = this.isOnWhat(pos, this.drawer_group, this.coef.shapesLayerw);
    const lastDrawer = {bottom: null};
    if (isOnWhat) {
      if (this.getlastdrawer(isOnWhat, lastDrawer)) {
        contours['top'] = this.getlastdrawer(isOnWhat, lastDrawer);
      }
    }
    let height = this.coef.drawer.drawHeight;
    if (heightDrawer) {
      height = heightDrawer;
    }
    if (this.blockDrawerCreate(contours, pos)) {
      const width = contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width;
      const drawer_group_create = new Konva.Group({
        x: contours['left'].attrs.x + contours['left'].attrs.width,
        y: contours['top'].attrs.y + (contours['top'].attrs.height ? contours['top'].attrs.height : contours['top'].attrs.params.height),
        name: 'element' + this.coef.countNameElement,
        width: contours['right'].attrs.x - contours['left'].attrs.x - contours['left'].attrs.width,
        params: {
          removable: true,
          type: this.coef.id_element.drawer,
          height: height,
          subId: this.subId
        },
        bind: [],
      });
      const drawerRectCreate = new Konva.Rect({
        x: 0,
        y: 0,
        width: drawer_group_create['attrs'].width,
        height: height,
        name: 'width',
        fill: this.coef.color,
        strokeWidth: 1,
        stroke: 'black',
      });
      const drawerCenterCreate = new Konva.Rect({
        x: (contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 2 - 16 / 2,
        y: (height / 2) - 5 / 2,
        width: 16,
        height: 5,
        name: 'width',
        fill: this.coef.silverColor,
        strokeWidth: 1,
        stroke: 'black',
      });
      const drawerCenterCreate3 = new Konva.Rect({
        x: (((contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3) * 2) - 16 / 2,
        y: (height / 2) - 5 / 2,
        width: 16,
        height: 5,
        name: 'width',
        fill: this.coef.silverColor,
        strokeWidth: 1,
        stroke: 'black',
      });
      const drawerCenterCreate4 = new Konva.Rect({
        x: (((contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3) * 2) - 16 / 2,
        y: (height / 2) - 5 / 2,
        width: 16,
        height: 5,
        name: 'width',
        fill: this.coef.silverColor,
        strokeWidth: 1,
        stroke: 'black',
        visible: false,
      });
      const drawerCenterCreate2 = new Konva.Rect({
        x: (contours['right'].attrs.x - contours['left'].attrs.x - this.coef.global_size_flat) / 3 - 16 / 2,
        y: (height / 2) - 5 / 2,
        width: 16,
        height: 5,
        name: 'width',
        fill: this.coef.silverColor,
        strokeWidth: 1,
        stroke: 'black',
      });
      this.create.bindingTocounters(
        contours['left'],
        contours['right'],
        contours['top'],
        contours['bottom'],
        drawer_group_create,
        'horizon',
      );
      const drawerText= new Konva.Text({
        x: (contours['right'].attrs.x - contours['left'].attrs.x ) - 20,
        y: 10,
        text: 'Д',
        fontSize: 15,
        fontFamily: 'Calibri',
        fill: 'black'
      });
      let lock = this.createLockDesigne();
      drawer_group_create.add(drawerRectCreate);
      if (width * this.coef.global_coef >= this.coef.drawer.secondSeparattor) {
        drawer_group_create.add(drawerCenterCreate2);
        drawer_group_create.add(drawerCenterCreate3);
      } else {
        drawer_group_create.add(drawerCenterCreate);
        drawer_group_create.add(drawerCenterCreate4);
      }
      drawer_group_create.add(drawerText)
      drawer_group_create.add(lock[0]);
      drawer_group_create.add(lock[1]);
      this.coef.shapesLayerw.add(drawer_group_create);
      this.coef.shapesLayerw.batchDraw();
      this.create.priceSend();
      if (heightDrawer) {
        drawer_group_create['attrs'].params.touches = 'Touched';
      }
      this.addHingePlankasToDrawer(drawer_group_create, contours, height, drawerRectCreate.fill());
      this.resizeDraw(drawer_group_create, contours, pos);
    }
  }
 

  blockDrawerCreate(contours, pos, id?) {
    console.log(contours , 'contours')
    return contours &&
      this.topBottomTangent(contours, true) &&
      this.blockDifDawer(contours['top'] ,this.subId)&&
      this.minTopLimitDrawer(contours['top']) &&
      this.chachWidthDrawer(contours, pos, id) &&
      this.chechLeftRight(contours) && this.stopCreateOnLevel(contours) &&
      this.coef.blockDrawerCentr(pos, contours);
  }

  // type 17: коли user-шухляда стає у секцію де лівий/правий контур (боковина/перегородка/стик)
  // має петлі, додаємо фальш-панелі ("планки"). Створюємо ЗАВЖДИ 3 планки на кожен бік
  // (всі однакової ширини = global_size_flat), показуємо/ховаємо за станом завіс.
  // Реактивність:
  //  - drag контурів → пересувається права група планок + декорації.
  //  - drag висоти (стек/верх. полиця) → ResizArray у create.ts оновлює height усіх isHingePlanka.
  //  - drag самої петлі (Y) → recompute через окремий хук у hinged-facade-section.ts
  //    що кличе recomputeDrawerPlanks для усіх шухляд на цьому контурі.
  addHingePlankasToDrawer(drawer_group, contours, drawerH, fillColor) {
    if (this.coef.pramsId != 17) return;
    const flatPx = this.coef.global_size_flat;
    const groupW = drawer_group.attrs.width || 0;
    // Зберігаємо контури/висоту на групі — щоб recomputeDrawerPlanks (зовнішній) мав до них доступ.
    drawer_group.attrs.params.drawerContours = contours;
    drawer_group.attrs.params.drawerHforPlanks = drawerH;
    // Створюємо 3 планки на ЛІВОМУ боці. index 0..2 від x=0 праворуч.
    // (index 0 — зовнішня, біля контуру; index 2 — найвнутрішня).
    for (let i = 0; i < 3; i++) {
      drawer_group.add(new Konva.Rect({
        x: i * flatPx, y: 0, width: flatPx, height: drawerH,
        fill: fillColor, stroke: 'black', strokeWidth: 1, listening: false, visible: false,
        params: {isHingePlanka: true, side: 'left', index: i}
      }));
    }
    // Створюємо 3 планки на ПРАВОМУ боці. index 0..2 від лівої частини стека до краю.
    // index 0 — найвнутрішня (groupW - 3×flat), index 2 — зовнішня (groupW - flat).
    for (let i = 0; i < 3; i++) {
      drawer_group.add(new Konva.Rect({
        x: groupW - (3 - i) * flatPx, y: 0, width: flatPx, height: drawerH,
        fill: fillColor, stroke: 'black', strokeWidth: 1, listening: false, visible: false,
        params: {isHingePlanka: true, side: 'right', index: i}
      }));
    }
    // Зберігаємо closure-callback на групі — щоб ResizArray (create.ts) і інші місця
    // могли перерахувати планки без circular-import.
    const coefRef = this.coef;
    drawer_group.attrs.params._recomputePlanks = () => Drawer.recomputeDrawerPlanks(drawer_group, coefRef);
    // Перший рендер — обчислюємо який стан планок для цієї шухляди.
    Drawer.recomputeDrawerPlanks(drawer_group, this.coef);
    // Додатково перерахувати ВСІ шухляди колонки — бо додавання нової міняє combined Y range
    // (нова шухляда може покрити петлю що раніше була поза діапазоном — інші шухляди
    // мали мати інші panel-count).
    Drawer.recomputeColumnDrawers(drawer_group, this.coef);
    // На драг контурів — оновити позиції правих планок + декорацій (висоту не чіпаємо).
    const onContourDrag = () => {
      if (!drawer_group.parent) return;
      Drawer.recomputeDrawerPlanks(drawer_group, this.coef);
    };
    if (contours['left']) contours['left'].on('dragmove.drawerHingePlanka', onContourDrag);
    if (contours['right']) contours['right'].on('dragmove.drawerHingePlanka', onContourDrag);
  }

  // Фальш-панелі ("планки") на одному боці шухляди + прапорець для бекенду.
  // count: немає петель у бік шухляди — 0; боковина — зовнішні фасади 1, внутрішні 2;
  // перегородка — 2, або 1 якщо всі петлі в бік шухляди накладні ('outer': перегородку
  // зсунуто під дверку від відкритої секції).
  // hit: чи петля по Y попадає на шухляди колонки — лише флаг, на count не впливає.
  // Static — щоб можна було викликати з HingedFacadeSection без створення Drawer instance.
  static computeDrawerPanelsForSide(drawer_group: any, contour: any, side: 'leftOfDrawer' | 'rightOfDrawer', coef: any): {count: number, hit: boolean} {
    const none = {count: 0, hit: false};
    if (!contour || !contour.attrs || !contour.attrs.params) return none;
    const cp = contour.attrs.params;
    const isLateral = cp.type === coef.id_element.lateral_wall;
    const isPartition = cp.type === coef.id_element.partition
                     || cp.type === coef.id_element.double_partition;
    if (!isLateral && !isPartition) return none;
    const hb = cp.hingeBind;
    // Якщо взагалі немає петель на контурі — 0 планок (ні для боковини, ні для перегородки).
    if (!Array.isArray(hb) || hb.length === 0) return none;
    const contourCenter = contour.attrs.x + (contour.attrs.width || 0) / 2;
    // Фільтр петель за напрямком (стирчать у бік шухляди).
    const facing: any[] = [];
    for (const h of hb) {
      if (!h || !h.attrs) continue;
      const hL = h.attrs.x;
      const hR = h.attrs.x + (h.attrs.width || 0);
      if (side === 'leftOfDrawer' && hL >= contourCenter) facing.push(h);
      else if (side === 'rightOfDrawer' && hR <= contourCenter) facing.push(h);
    }
    // Якщо ВСІ петлі дивляться у сусідню колонку (не нашу) — теж 0 планок.
    if (facing.length === 0) return none;
    // Y-перекриття — ПРОТИ ОБ'ЄДНАНОГО Y-діапазону всіх шухляд КОЛОНКИ, не тільки цієї.
    // Колонка = шухляди з тими самими лівим і правим контурами. Якщо хоч одна шухляда
    // колонки попадає на петлю, то планки додаються до УСІХ шухляд колонки — щоб
    // візуально планка йшла суцільно через всю групу.
    const thisContours = drawer_group.attrs.params.drawerContours || {};
    const drawerType = coef.id_element.drawer;
    const sLayer = coef.shapesLayerw;
    const colMates: any[] = [];
    if (sLayer && sLayer.children) {
      for (const c of sLayer.children) {
        if (!c || !c.attrs || !c.attrs.params) continue;
        if (c.attrs.params.type !== drawerType) continue;
        const cc = c.attrs.params.drawerContours;
        if (!cc) continue;
        if (cc.left === thisContours.left && cc.right === thisContours.right) {
          colMates.push(c);
        }
      }
    }
    if (colMates.length === 0) colMates.push(drawer_group);
    let minY = Infinity, maxY = -Infinity;
    for (const d of colMates) {
      const dY = d.attrs.y;
      const dH = (d.children && d.children[0] && d.children[0].attrs.height) || 0;
      if (dY < minY) minY = dY;
      if (dY + dH > maxY) maxY = dY + dH;
    }
    const hit = facing.some((h: any) => {
      const hY = h.attrs.y;
      const hH = h.attrs.height || 0;
      return !(hY + hH <= minY || hY >= maxY);
    });
    if (isLateral) {
      const inset = facing.some((h: any) => h.attrs.params && h.attrs.params.isInset);
      return {count: inset ? 2 : 1, hit: hit};
    }
    const factory = coef.hingedFactory;
    const allOuter = !!factory && facing.every((h: any) => factory.hingeTypeOf(h) === 'outer');
    return {count: allOuter ? 1 : 2, hit: hit};
  }

  // Перерахувати плани для ВСІХ шухляд тієї самої колонки (з тими самими контурами).
  // Викликається коли combined Y колонки може змінитися: додано/видалено шухляду, ResizArray.
  static recomputeColumnDrawers(anyDrawerInColumn: any, coef: any) {
    if (!anyDrawerInColumn || !anyDrawerInColumn.attrs || !anyDrawerInColumn.attrs.params) return;
    const thisContours = anyDrawerInColumn.attrs.params.drawerContours;
    if (!thisContours) return;
    const drawerType = coef.id_element.drawer;
    const sLayer = coef.shapesLayerw;
    if (!sLayer || !sLayer.children) return;
    for (const c of sLayer.children) {
      if (!c || !c.attrs || !c.attrs.params) continue;
      if (c.attrs.params.type !== drawerType) continue;
      const cc = c.attrs.params.drawerContours;
      if (!cc) continue;
      if (cc.left === thisContours.left && cc.right === thisContours.right) {
        Drawer.recomputeDrawerPlanks(c, coef);
      }
    }
  }

  // Перерахувати visibility всіх 6 планок шухляди + перепозиціонувати праві + зсунути декорації.
  // Static — щоб HingedFacadeSection міг викликати при drag петлі.
  static recomputeDrawerPlanks(drawer_group: any, coef: any) {
    if (!drawer_group || !drawer_group.attrs || !drawer_group.children) return;
    const contours = drawer_group.attrs.params.drawerContours;
    if (!contours) return;
    const flatPx = coef.global_size_flat;
    const sideL = Drawer.computeDrawerPanelsForSide(drawer_group, contours['left'], 'leftOfDrawer', coef);
    const sideR = Drawer.computeDrawerPanelsForSide(drawer_group, contours['right'], 'rightOfDrawer', coef);
    const panelsL = sideL.count;
    const panelsR = sideR.count;
    // Для бекенду: чи петля контуру по висоті попадає на шухляди колонки (на кількість не впливає).
    drawer_group.attrs.params.plankaHingeHitL = sideL.hit;
    drawer_group.attrs.params.plankaHingeHitR = sideR.hit;
    const curGroupW = (contours['right'] && contours['right'].attrs.x - drawer_group.attrs.x) || drawer_group.attrs.width || 0;
    // Оновити visibility + позицію кожної планки.
    for (const c of drawer_group.children) {
      if (!c || !c.attrs || !c.attrs.params || !c.attrs.params.isHingePlanka) continue;
      const idx = c.attrs.params.index;
      if (c.attrs.params.side === 'left') {
        // Показуємо index 0..(panelsL-1).
        c.visible(idx < panelsL);
        // x: index * flatPx (fixed, anchored to left).
        c.x(idx * flatPx);
      } else {
        // Праві: показуємо index (3-panelsR)..2.
        c.visible(idx >= 3 - panelsR);
        // x: groupW - (3-idx) * flatPx (anchored to right edge).
        c.x(curGroupW - (3 - idx) * flatPx);
      }
    }
    const wL = panelsL * flatPx;
    const wR = panelsR * flatPx;
    drawer_group.attrs.params.plankaShiftL = wL;
    drawer_group.attrs.params.plankaShiftR = wR;
    // Зсув декорацій (замок/ключ/Д/смужка) — як було.
    for (const c of drawer_group.children) {
      if (!c || !c.attrs) continue;
      const cp = c.attrs.params;
      if (cp && cp.isHingePlanka) continue;
      if (c.className === 'Circle' && c.attrs.x < 30 + wL && wL >= 0) {
        c.x(10 + wL);
        continue;
      }
      if (c.className === 'Rect' && c.attrs.width === 2 && c.attrs.fill === 'black' && c.attrs.x < 30 + wL) {
        c.x(9 + wL);
        continue;
      }
      if (c.className === 'Text' && c.attrs.text === 'Д') {
        c.x(curGroupW - wR - 20);
        continue;
      }
      if (c.className === 'Rect' && c.attrs.y === 0 && c.attrs.height === 5 && c.attrs.fill === '#6c6c6c') {
        c.x(wL);
        c.width(Math.max(0, curGroupW - wL - wR));
        continue;
      }
    }
    const layer = drawer_group.getLayer && drawer_group.getLayer();
    if (layer && layer.batchDraw) layer.batchDraw();
  }
}
